export default __webpack_public_path__ + "static/media/huawei_download_image.0c180efa.png";